/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, createRoute } from 'framework/routing';
import { GlobalProtectedRoute } from 'framework/authorization';

import ContractsContext from 'domain/people/contracts/ContractsContext';

import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ViewPage from 'domain/people/contracts/Show';
import ListPage from 'domain/people/contracts/List';

import { GET_ALL_CONTRACTS_LIST, READ_CONTRACT } from 'domain/people/contracts/shared/contractsService';
import { CONTRACTS_PATH } from './contractsRouting';

const useContractsRoute = () => {
  return createRoute({ listRoute: CONTRACTS_PATH });
};

const ContractsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useContractsRoute();

  return (
    <ProtectedRouter basePath={CONTRACTS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={GET_ALL_CONTRACTS_LIST}>
              <ListPage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <ContractsContext permissionToCheck={READ_CONTRACT}>
              <ViewPage />
            </ContractsContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ContractsRouter.getRouterPath = () => `${CONTRACTS_PATH}/*`;

export default ContractsRouter;
